var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoutIconTfi(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "@0.5xicon/logout/TFI blue") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Core",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Main-(with-icons)",
    transform: "translate(-1217.000000, -103.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/logout/TFI-blue",
    transform: "translate(1218.000000, 104.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10,0 L2,0 C0.8954305,2.02906125e-16 -1.3527075e-16,0.8954305 0,2 L0,18 C1.3527075e-16,19.1045695 0.8954305,20 2,20 L10,20",
    id: "Path-3",
    stroke: "#002C56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#002C56",
    x: 7,
    y: 10,
    width: 13,
    height: 1
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-4",
    stroke: "#002C56",
    points: "15 5.5 20 10.5 15 15.5"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutIconTfi);
export default __webpack_public_path__ + "static/media/logout_icon_tfi.2a5b9670337202863578252ae222b013.svg";
export { ForwardRef as ReactComponent };